import { Component, OnInit, Input } from '@angular/core';

// Models
import { User } from '../../models/user.model';

// Services
import { UserSessionService } from '../../services/user/user.service';
import { SidebarService } from '../../services/shared/sidebar.service';
import { SettingsService } from '../../services/settings/settings.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MixpanelService } from 'src/app/services/analytics/mixpanel.service';
import { PrivateRoutes } from 'src/app/config/config.routes';
import { mixpanelEvent } from 'src/app/config/mixpanel-events';
import { NgClass } from '@angular/common';

/**
 * Component to manage the sidebar component
 */
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  imports: [NgClass, RouterLink, RouterLinkActive],
})
export class SidebarComponent implements OnInit {
  /**
   * The color variable is declared
   * @param color Variable to keep colour
   */
  color: string;
  /**
   * The theme variable is declared
   * @param theme Variable to keep page theme
   */
  theme?: string;
  /**
   * The user variable is declared
   * @param user Variable to save the connected user data
   */
  user!: User;
  redirect!: string;

  /** Items of the Menu */
  @Input() sidebarElements: any;

  userId = this.UserSessionService.getId();

  homeSection = '';

  /**
   *   @param toggleSidebar to change state of the sidebar
   */
  toggleSidebar = false;
  /**
   * Following variables declared
   * @param UserSessionService Service that brings users data and functions
   * @param settings Service that works the page colour
   * @param sidebarService Service that works with the sidebar and the app of the page
   */
  constructor(
    public UserSessionService: UserSessionService,
    public settings: SettingsService,
    public sidebarService: SidebarService,
    public mixpanelService: MixpanelService,
    public router: Router,
  ) {
    this.color = settings.getColor();
  }

  /**
   * Data is saved in the {@link ../injectables/UserSessionService.html|UserSessionService.user} on the user variable
   */
  ngOnInit() {
    this.user = this.UserSessionService.user;

    this.homeSection = PrivateRoutes.HOME;
  }

  /**
   * Function that applies colour, changing the app. At the end does a reload to make the new requests
   * @param theme Variable that brings the colour you want to apply according to the selection made by the user
   */
  changeColor(theme: string) {
    const route = this.router.url.substring(0, 6);
    this.theme = theme;
    this.settings.applyTheme(this.theme);
    this.color = this.settings.getColor();
    if (this.color === 'red') {
      this.sidebarService.applyApp('LAB4PHYSICS');
    } else if (this.color === 'green') {
      this.sidebarService.applyApp('LAB4BIOLOGY');
    } else {
      this.sidebarService.applyApp('LAB4CHEMISTRY');
    }
    if (this.router.url.length > 25) {
      if (route === '/exper') {
        this.router.navigate(['/categories']);
      } else if (route === '/tool/') {
        this.router.navigate(['/tools']);
      } else {
        window.location.reload();
      }
    } else {
      window.location.reload();
    }
  }

  sidebarShowSection(section_title: string) {
    this.mixpanelService.track(
      `sidebar_show_section_${section_title.slice(1)}`,
      { 'User type': this.UserSessionService.getRole() },
    );
  }

  toggleShowSidebar = () => {
    this.toggleSidebar = !this.toggleSidebar;
  };

  leftSidebarSelected(section_url: string) {
    if (section_url === '/general-documents') {
      this.mixpanelService.track(
        mixpanelEvent.LEFT_SIDEBAR_RESOURCES_SELECTED,
        {
          source_name: 'LAB4UPORTAL',
        },
      );
    }
    if (section_url === '/home') {
      this.mixpanelService.track(
        mixpanelEvent.LEFT_SIDEBAR_HOME_BUTTON_SELECTED,
        {
          source_name: 'LAB4UPORTAL',
        },
      );
    }
    if (section_url === '/log-out') this.triggerSignOutSucceededEvent();
    this.toggleShowSidebar();
  }

  logoSelected() {
    this.mixpanelService.track(
      mixpanelEvent.LEFT_SIDEBAR_LAB4UPORTAL_LOGO_SELECTED,
      {
        source_name: 'LAB4UPORTAL',
      },
    );
  }

  supportSelected() {
    this.mixpanelService.track(mixpanelEvent.LEFT_SIDEBAR_SUPPORT_SELECTED, {
      source_name: 'LAB4UPORTAL',
    });
  }

  triggerSignOutSucceededEvent() {
    this.mixpanelService.track(mixpanelEvent.SIGN_OUT, {
      source_name: mixpanelEvent.SOURCE_NAME,
      feature_name: 'Miscelanea',
      view_name: 'Miscelanea',
      event_version: 1,
      event_id: 80,
      event_type: 'Click',
    });
  }
}
